import { render, staticRenderFns } from "./MeEditorSystemEmoticon.vue?vue&type=template&id=252354e0&scoped=true"
import script from "./MeEditorSystemEmoticon.vue?vue&type=script&lang=js"
export * from "./MeEditorSystemEmoticon.vue?vue&type=script&lang=js"
import style0 from "./MeEditorSystemEmoticon.vue?vue&type=style&index=0&id=252354e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252354e0",
  null
  
)

export default component.exports